import type { StepExplainer, StepExplainerId } from "@louise/care/education";
import { StepExplainerPanels } from "@louise/care/education/StepExplainerPanels";
import { OrganicMiniIcon, type OrganicMiniIconKind } from "./OrganicMiniIcon";
import { TimelineSubtaskCard } from "./TimelineTaskComponents";

/** The organic icon in the card's header, by what the step is about. */
const EXPLAINER_ICONS: Record<StepExplainerId, OrganicMiniIconKind> = {
  pre_treatment_stimulated: "start",
  pre_treatment_fet: "start",
  pre_treatment_iui_oi: "start",
  pre_treatment_sperm: "sperm",
  ovarian_stimulation_ivf: "hormones",
  ovarian_stimulation_iui: "hormones",
  ovulation_induction: "hormones",
  lining_preparation: "process",
  trigger_shot: "hormones",
  egg_retrieval: "eggs",
  sperm_collection: "sperm",
  fertilization: "genetics",
  embryo_development: "genetics",
  pgt: "genetics",
  freezing_eggs: "cryo",
  freezing_sperm: "cryo",
  semen_analysis: "panel",
  screening: "panel",
  embryo_transfer: "process",
  insemination: "process",
  luteal_support: "hormones",
  wait_after_transfer: "start",
  wait_after_insemination_or_ovulation: "start",
};

/**
 * Home's card for the step she is on: the treatment hub's explainer for that
 * step, every section shown in full, folded under its title like the other
 * Home cards and open by default.
 */
export function StepExplainerCard({ explainer }: { explainer: StepExplainer }) {
  return (
    <TimelineSubtaskCard
      id={`step-explainers.${explainer.id}`}
      title={explainer.title}
      titleIcon={
        <OrganicMiniIcon kind={EXPLAINER_ICONS[explainer.id]} size={34} />
      }
    >
      <StepExplainerPanels
        explainer={explainer}
        // The same step can change its words (her clinic's instructions come
        // in, the language changes), so the panels are measured again then.
        measureKey={`home-${explainer.id}-${explainer.sections
          .map((section) => section.items.join("").length)
          .join(".")}`}
      />
    </TimelineSubtaskCard>
  );
}
